exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".AssessmentComparisonGraph_root{position:relative}.AssessmentComparisonGraph_selects_container{display:flex;flex-wrap:wrap}.AssessmentComparisonGraph_selects_container>div{margin-bottom:20px}.AssessmentComparisonGraph_selects_container>div:first-child{margin-right:30px}.AssessmentComparisonGraph_selects_container legend{border-bottom:0}.AssessmentComparisonGraph_hidden_data_msg{font-size:12px;margin-bottom:20px}\n", ""]);

// Exports
exports.locals = {
	"root": "AssessmentComparisonGraph_root",
	"selects_container": "AssessmentComparisonGraph_selects_container",
	"hidden_data_msg": "AssessmentComparisonGraph_hidden_data_msg"
};